import MDinput from '@/components/MDinput';
import DateTimePicker from '@/components/DSE/DateTimePicker';
import InputNumber from '@/components/DSE/InputNumber';
import Switch from '@/components/DSE/Switch';

export function getFormDefinition(vue) {
  const validateRequire = function(rule, value, callback) {
    if (!value) {
      callback(new Error(vue.$i18n.t('validation.required')));
    } else {
      callback();
    }
  };
  return {
    customerName: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        required: true,
        caption: 'customer.customerName'
      },
      rules: [
        {
          validator: validateRequire
        }
      ]
    },
    customerLocation: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 64,
        caption: 'customer.customerLocation'
      }
    },
    licenseKey: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 49,
        required: false,
        caption: 'customer.licenseKey',
        placeholder: vue.$i18n.t('customer.autoGenerateLicenseKey')
      }
    },
    version: {
      type: InputNumber,
      defaultValue: 1,
      props: {
        caption: 'customer.version',
        min: 1
      }
    },
    numberOfLicenses: {
      type: InputNumber,
      defaultValue: 0,
      props: {
        caption: 'customer.numberOfLicenses'
      }
    },
    userCount: {
      type: InputNumber,
      defaultValue: 0,
      props: {
        caption: 'customer.userCount'
      }
    },
    refreshXDays: {
      type: InputNumber,
      defaultValue: 1,
      props: {
        caption: 'customer.refreshXDays',
        min: 1,
        max: 365
      }
    },
    dateIssued: {
      type: DateTimePicker,
      defaultValue: '',
      props: {
        required: true,
        format: 'dd-MM-yyyy',
        caption: 'customer.dateIssued'
      },
      rules: [
        {
          validator: validateRequire
        }
      ]
    },
    validUntilDate: {
      type: DateTimePicker,
      defaultValue: '',
      props: {
        format: 'dd-MM-yyyy',
        caption: 'customer.validUntilDate'
      }
    },
    locked: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'customer.locked'
      }
    },
    isMobileAllowed: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'customer.isMobileAllowed'
      }
    },
    renewalPossible: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'customer.renewalPossible'
      }
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
